import { SET_INITIAL_THEME_MODE, SET_THEME_MODE, TOGGLE_DARK_MODE } from './ActionConstant';

export function toggleThemeMode() {
  return {
    type: TOGGLE_DARK_MODE,
  };
}

export function setInitialThemeMode() {
  return {
    type: SET_INITIAL_THEME_MODE,
  };
}

export function setThemeMode(data) {
  return {
    type: SET_THEME_MODE,
    data,
  };
}
